import { Directive } from '@angular/core';

@Directive({
  selector: '[appTableFooter]'
})
export class TableFooterDirective { }
